import React, { useState } from "react";
import { useAuth } from "../../firebase/AuthProvider";
import SignInDialog from "../signin/SigninDialog";
import { IconButton } from "@material-ui/core";
import FlaggedIcon from "@material-ui/icons/Flag";
import UnflaggedIcon from "@material-ui/icons/FlagOutlined";
import Confirmation from "../shared/Confirmation";
import { useTranslation } from "react-i18next";
import Tooltip from "../shared/Tooltip";

interface Props {
  flagged: boolean;
  flag: () => Promise<void>;
  unflag: () => Promise<void>;
}

export default function Flag({ flagged, flag, unflag }: Props) {
  const { t } = useTranslation();
  const { isSignedIn } = useAuth();
  const [openSignInDialog, setOpenSignInDialog] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [flagOrUnflag, setFlagOrUnflag] = useState<string | null>(null);

  async function handleFlagUnflag() {
    if (!isSignedIn) {
      setOpenSignInDialog(true);
      return;
    }

    if (!flagOrUnflag) return;

    setIsLoading(true);
    flagOrUnflag === "flag" ? flag() : unflag();
    setIsLoading(false);
  }

  return (
    <>
      <SignInDialog
        open={openSignInDialog}
        onClose={() => setOpenSignInDialog(false)}
      />
      <div>
        {flagged ? (
          <Tooltip title={t("comment.unflagtooltip")}>
            <IconButton
              onClick={() => setFlagOrUnflag("unflag")}
              disabled={isLoading}
              aria-label={t("comment.unflagtooltip")}
            >
              <FlaggedIcon />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title={t("comment.flagtooltip")}>
            <IconButton
              onClick={() => setFlagOrUnflag("flag")}
              disabled={isLoading}
              aria-label={t("comment.flagtooltip")}
            >
              <UnflaggedIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>

      {flagOrUnflag && (
        <Confirmation
          text={
            flagOrUnflag === "flag"
              ? t("comment.confirmflag")
              : t("comment.confirmunflag")
          }
          handleConfirm={async () => {
            handleFlagUnflag();
            setFlagOrUnflag(null);
          }}
          handleCancel={() => setFlagOrUnflag(null)}
        />
      )}
    </>
  );
}
